import React from 'react';
import { motion } from 'framer-motion';
export function CtaFooter() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-gradient-to-b from-emerald-800 to-emerald-950 text-white pt-20 pb-8 relative overflow-hidden" data-id="element-33">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-34">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-emerald-600 rounded-full blur-3xl opacity-30" data-id="element-35"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-700 rounded-full blur-3xl opacity-30 translate-y-1/2 translate-x-1/4" data-id="element-36"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-38">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-8 tracking-tight" data-id="element-39">
            Hacé clic y empezá hoy.
          </h2>
          <button onClick={scrollToPricing} className="bg-white text-emerald-900 hover:bg-gray-50 text-lg font-bold py-4 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto" data-id="element-40">
            Acceder ahora{' '}
            <span className="text-xl leading-none transition-transform group-hover:translate-x-1" data-id="element-41">
              →
            </span>
          </button>
        </motion.div>

        <div className="pt-8 flex flex-col items-center" data-id="element-42">
          <p className="text-emerald-200/60 text-sm font-medium" data-id="element-43">
            © 2026 Sistema PRO. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}